import { render, staticRenderFns } from "./FullScreenGDriveVideoDialog.vue?vue&type=template&id=11fa0822&scoped=true&"
import script from "./FullScreenGDriveVideoDialog.vue?vue&type=script&lang=js&"
export * from "./FullScreenGDriveVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenGDriveVideoDialog.vue?vue&type=style&index=0&id=11fa0822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa0822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VFabTransition,VIcon})
